/** @format */

import React from "react";
import { Link } from "react-router-dom";
import Bottom from "../assets/images/bottom.png";
import Top from "../assets/images/top.png";
import Code from "../assets/images/code.png";
import Write from "../assets/images/write.png";
import Folder from "../assets/images/folder.png";

function gotoTop () {
	window.scrollTo(0, 0);
}

const Hire = () => {
	return (
		<>
			<div className="row pt-2 hidden">
				<div className="col-lg-6 pr order-2 order-lg-1 hire-top">
					<img src={Bottom} alt="" className="hire bottom" />
					<img src={Top} alt="" className="hire top" />
				</div>
				<div className="col-lg-6 px-2 order-1 order-lg-2">
					<h4 className="text-center font-weight-bold">
						Why hire me for your next project?
					</h4>
					<p className="text-center">
						Do you want a befitting website for your business? Do
						you have a project you are working on and you need
						collaborators?
					</p>
					<div className="hire-btn">
						<Link to="/hire" onClick={gotoTop}>
							<button className="btn btn-success">
								Let&apos;s discuss
							</button>
						</Link>
					</div>

					<div className="row pt-2">
						<div className="col-4 brand-block px-2">
							<div>
								<div className="brands">
									<img src={Code} alt="" />
								</div>
								<p className="text-center">
									Front-End Web Developer
								</p>
							</div>
						</div>
						<div className="col-4 brand-block px-2">
							<div>
								<div className="brands">
									<img src={Write} alt="" />
								</div>
								<p className="text-center">
									Technical Article Writer
								</p>
							</div>
						</div>
						<div className="col-4 brand-block px-2">
							<div>
								<div className="brands">
									<img src={Folder} alt="" />
								</div>
								<p className="text-center">
									Open Source Enthusiast
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Hire;
